export default __webpack_public_path__ + "static/media/permitir.f6d88028.svg";